module.exports = __webpack_public_path__ + "img/cheese-chicken.05b5078c.svg";